"use strict";
// Times of day read with am/pm — "3:45 pm", never "15:45" (product owner, 2026-10-25, D10):
// on the 24-hour clock 03:45 was picked for an afternoon interview and refused as "in the
// past". Display only: stored and sent values stay `HH:mm` and UTC instants (#8). One
// helper for the web app and the server's emails, so the two can never disagree.
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatClock = formatClock;
exports.formatClockRange = formatClockRange;
const CLOCK_PATTERN = /^(\d{1,2}):(\d{2})/;
const HOURS_PER_DAY = 24;
const HOURS_PER_HALF_DAY = 12;
/**
 * `HH:mm` (or Postgres's `HH:mm:ss`) as "3:45 pm". Midnight is "12:00 am" and noon
 * "12:00 pm"; the slot finder's end-of-day `24:00` is midnight too. Anything that is not
 * a clock time comes back unchanged rather than as a wrong time.
 */
function formatClock(time) {
    const match = CLOCK_PATTERN.exec(time);
    if (!match)
        return time;
    const hours = Number(match[1]) % HOURS_PER_DAY;
    const period = hours < HOURS_PER_HALF_DAY ? 'am' : 'pm';
    const hour = hours % HOURS_PER_HALF_DAY === 0 ? HOURS_PER_HALF_DAY : hours % HOURS_PER_HALF_DAY;
    return `${hour}:${match[2]} ${period}`;
}
/** Working hours or a shift, "9:00 am–6:00 pm". */
function formatClockRange(start, end) {
    return `${formatClock(start)}–${formatClock(end)}`;
}
//# sourceMappingURL=clock.js.map